<template>
    <div
        role="status"
        aria-live="polite"
        :aria-label="localizations[lang].loading"
        class="SimpleSpinner"
        :style="{ width: width + 3, height: height + 3 }"
    >
        <svg-icon
            aria-hidden="true"
            icon="spinner"
            class="animate-spin text-theme-toolbar-icon [&_svg]:m-0"
            :width="width"
            :height="height"
        />
    </div>
</template>
<script>
import { mapState } from 'vuex';

export default {
    name: 'SimpleSpinner',
    props: {
        height: {
            type: [String, Number],
            default: 32,
        },
        width: {
            type: [String, Number],
            default: 32,
        },
    },
    computed: {
        ...mapState(['localizations', 'lang']),
    },
};
</script>
<style lang="scss" scoped>
.SimpleSpinner {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center svg {
        position: absolute;
        z-index: 999;
        height: 2em;
        width: 2em;
        overflow: show;
        margin: auto;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
    }

    // Here is where the magic happens
    $offset: 187;
    $duration: 1.4s;
    &-spinner {
        animation: rotator $duration linear infinite;
    }
    @keyframes rotator {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(270deg);
        }
    }
    .path {
        stroke: #bdbdbd;
        stroke-dasharray: $offset;
        stroke-dashoffset: 0;
        transform-origin: center;
        animation: dash $duration ease-in-out infinite;
    }
    @keyframes dash {
        0% {
            stroke-dashoffset: $offset;
        }
        50% {
            stroke-dashoffset: calc($offset / 4);
            transform: rotate(135deg);
        }
        100% {
            stroke-dashoffset: $offset;
            transform: rotate(450deg);
        }
    }
}
</style>
